module.exports = __webpack_public_path__ + "static/media/room-3.f9f1c45e.jpg";